
const digest = 'b5abf5aee496a9ff6d956064d14c7d5e56020c4b0ff9879075a2c5380ee59702';
const classes = {"wrapper":"_wrapper_u4prh_1","controls":"_controls_u4prh_8","list":"_list_u4prh_12"};
const css = `._wrapper_u4prh_1 {
  font-family: Rubik, "sans-serif";
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
._wrapper_u4prh_1 ._controls_u4prh_8 {
  padding: 12px 24px;
  border: 1px solid #eaedf3;
}
._wrapper_u4prh_1 ._list_u4prh_12 {
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  padding: 24px;
  gap: 25px;
  display: flex;
  flex-direction: column;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  